export const PaymentConstants = {
  defaultCurrency: '$',
};
